export const COUNTRY_OPTIONS = [
  { label: 'Nigeria', value: 'Nigeria' },
  { label: 'Ghana', value: 'Ghana' },
  { label: 'Kenya', value: 'Kenya' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'United Kingdom', value: 'United Kingdom' },
  { label: 'United States', value: 'United States' },
  { label: 'Canada', value: 'Canada' },
  { label: 'Other', value: 'Other' },
];

export const STATE_OPTIONS_BY_COUNTRY: Record<
  string,
  { label: string; value: string }[]
> = {
  Nigeria: [
    { label: 'Lagos', value: 'Lagos' },
    { label: 'Abuja', value: 'Abuja' },
    { label: 'Kano', value: 'Kano' },
    { label: 'Rivers', value: 'Rivers' },
    { label: 'Oyo', value: 'Oyo' },
    { label: 'Kaduna', value: 'Kaduna' },
    { label: 'Anambra', value: 'Anambra' },
    { label: 'Delta', value: 'Delta' },
    { label: 'Ogun', value: 'Ogun' },
    { label: 'Other', value: 'Other' },
  ],
  Ghana: [
    { label: 'Greater Accra', value: 'Greater Accra' },
    { label: 'Ashanti', value: 'Ashanti' },
    { label: 'Western', value: 'Western' },
    { label: 'Other', value: 'Other' },
  ],
  Kenya: [
    { label: 'Nairobi', value: 'Nairobi' },
    { label: 'Mombasa', value: 'Mombasa' },
    { label: 'Kisumu', value: 'Kisumu' },
    { label: 'Other', value: 'Other' },
  ],
  'South Africa': [
    { label: 'Gauteng', value: 'Gauteng' },
    { label: 'Western Cape', value: 'Western Cape' },
    { label: 'KwaZulu-Natal', value: 'KwaZulu-Natal' },
    { label: 'Other', value: 'Other' },
  ],
  'United Kingdom': [
    { label: 'England', value: 'England' },
    { label: 'Scotland', value: 'Scotland' },
    { label: 'Wales', value: 'Wales' },
    { label: 'Northern Ireland', value: 'Northern Ireland' },
  ],
  'United States': [
    { label: 'California', value: 'California' },
    { label: 'Texas', value: 'Texas' },
    { label: 'New York', value: 'New York' },
    { label: 'Other', value: 'Other' },
  ],
  Canada: [
    { label: 'Ontario', value: 'Ontario' },
    { label: 'Quebec', value: 'Quebec' },
    { label: 'British Columbia', value: 'British Columbia' },
    { label: 'Other', value: 'Other' },
  ],
  Other: [{ label: 'Other', value: 'Other' }],
};

export const getStateOptionsForCountry = (
  country: string | null | undefined
) => {
  if (!country) return [];
  return (
    STATE_OPTIONS_BY_COUNTRY[country] ?? [{ label: country, value: country }]
  );
};
